import { AxiosService } from './axios.service'
import { RoleConstants } from '../constants'

/**
 * Defines the API methods for an user
 */
export class UserService {
	static baseURL = 'usuario'

	/**
	 * Gets the list of roles of current user
	 * @return {Promise<string[]>} lista de papéis/permissões do usuário autenticado
	 */
	static getRoles() {
		return AxiosService.get(`${this.baseURL}/funcoes`)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Register an user as intersted on Moveflex program
	 * @param {string} email The preuser's e-mail
	 */
	static registerPreUser(email) {
		return AxiosService.post(`${this.baseURL}/registrar-pre-usuario`, {
			email
		}).then(({ data }) => data)
	}

	static getFirstName(name) {
		return (name && name.split(' ')[0]) || ''
	}

	/**
	 * return the most important  role in an array of roles
	 * @param {string} roles User roles
	 */
	static getMostImportantRole(roles) {
		if (roles == undefined || roles == null) return RoleConstants.Admin
		if (roles.includes(RoleConstants.Admin)) {
			return RoleConstants.Admin
		} else if (roles.includes(RoleConstants.Partner)) {
			return RoleConstants.Partner
		} else if (roles.includes(RoleConstants.Client)) {
			return RoleConstants.Client
		} else return RoleConstants.Admin //Moveflex
	}
}
